import { Component, Input, OnInit } from '@angular/core';
import { ProgressType } from '../progress-type';
import { ProgressCircleDto } from './progress-circle-dto';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'lp2-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
})
export class ProgressCircleComponent implements OnInit {
  ProgressType = ProgressType;
  @Input() progressCircleDto: ProgressCircleDto;
  @Input() isWideStyle = true;
  @Input() circleRadius = 60;
  @Input() titleFontSize = '22px';
  @Input() subtitleFontSize = '16px';
  @Input() subtitleColor = '#444444';
  @Input() gamificationEnabled = false;
  @Input() hasDetailsContent = false;

  labelOf = '';

  constructor(private translate: TranslationService) {}

  ngOnInit() {
    this.labelOf = this.translate.translate('of');
  }

  get titleColor(): string {
    if (!(this.progressCircleDto && this.progressCircleDto.progressType)) {
      return '#0085ff';
    }

    switch (this.progressCircleDto.progressType) {
      case ProgressType.PRACTICES:
        return '#f228c1';
      case ProgressType.UNITS:
        return '#a0c13a';
      default:
        return '#0085ff';
    }
  }

  get subTitle(): string {
    return this.gamificationEnabled
      ? `${this.labelOf} ` +
          this.progressCircleDto.maxValue +
          (this.progressCircleDto.progressType === this.ProgressType.PRACTICES ? 'h' : '')
      : this.isWideStyle
      ? this.progressCircleDto.measurementUnit
      : '';
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/progress-circle/progress-circle.component.ts